"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const MountScroller_1 = __importDefault(require("../../../components/Util/MountScroller"));
const xstate_2 = require("../../lib/constants/xstate");
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
const Shimmer_1 = __importDefault(require("../../../components/Loading/Provider/Shimmer"));
const CancelPage_1 = __importDefault(require("../CancelPage"));
const ConfirmationPage_1 = __importDefault(require("../ConfirmationPage"));
const ErrorPage_1 = require("../ErrorPage");
function AppointmentCancel(_a) {
    var { service } = _a, props = __rest(_a, ["service"]);
    const [currentState] = (0, react_2.useService)(service);
    return (react_1.default.createElement(styles_1.Container, null,
        (0, utils_1.pendingStateMatchHelper)(currentState) && react_1.default.createElement(Shimmer_1.default, null),
        (0, utils_1.subStateMatchHelper)(xstate_2.states.error, currentState) && react_1.default.createElement(ErrorPage_1.ErrorPage, null),
        currentState && currentState.matches(xstate_2.states.appointmentMissed) && (react_1.default.createElement(ErrorPage_1.ErrorPageCancelDisabled, { service: service })),
        currentState && currentState.matches(xstate_2.states.cancelDisabled) && (react_1.default.createElement(ErrorPage_1.ErrorPageCancelDisabled, { service: service })),
        currentState && currentState.matches(xstate_2.states.cancelPage) && (react_1.default.createElement(CancelPage_1.default, { service: service, track: props.track })),
        (0, utils_1.canceledStateMatchHelper)(currentState) && (react_1.default.createElement(MountScroller_1.default, { alignToTop: true }, (ref) => (react_1.default.createElement(ConfirmationPage_1.default, { createRescheduleLink: props.createRescheduleLink, ref: ref, searchProvidersLink: props.searchProvidersLink, service: service, track: props.track }))))));
}
exports.default = AppointmentCancel;
AppointmentCancel.propTypes = {
    /**
     * Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider
     * @callback createRescheduleLink
     * @param {number} providerId
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * The interpreted appointmentCancelMachine that will handle the logic for this component
     */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    /**
     * Callback triggered for tracking
     * @callback track
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired,
    /**
     * URL link for the `Search Providers` button.
     */
    searchProvidersLink: prop_types_1.string.isRequired
};
AppointmentCancel.defaultProps = {};
//# sourceMappingURL=AppointmentCancel.js.map